import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Badge } from "@/components/ui/badge";
import { Trash2 } from "lucide-react";

export default function Actions() {
  const [actions, setActions] = useState([]);

  const load = async () => {
    const { data } = await api.get("/actions");
    setActions(data);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (id, done) => {
    const fd = new FormData();
    fd.append("done", String(done));
    await api.patch(`/actions/${id}`, fd);
    load();
  };

  const remove = async (id) => {
    if (!confirm("Supprimer cette action ?")) return;
    await api.delete(`/actions/${id}`);
    load();
  };

  const open = actions.filter((a) => !a.done);
  const done = actions.filter((a) => a.done);

  return (
    <div className="p-8 lg:p-10 max-w-5xl">
      <div className="mb-10">
        <div className="text-xs tracking-[0.3em] uppercase text-slate-500 mb-2">Prochaines actions</div>
        <h1 className="font-display text-4xl tracking-tight">À faire <span className="text-slate-400 font-mono text-2xl">({open.length})</span></h1>
      </div>

      <div className="border border-slate-200 bg-white">
        {open.length === 0 && <div className="p-12 text-center text-slate-500">Tout est à jour 🎯</div>}
        {open.map((a) => (
          <div key={a.id} className="flex items-center gap-4 p-4 border-b last:border-b-0 border-slate-100" data-testid={`action-row-${a.id}`}>
            <Checkbox checked={a.done} onCheckedChange={(v) => toggle(a.id, !!v)} data-testid={`action-check-${a.id}`} />
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <Badge className="bg-slate-900 text-white hover:bg-slate-900 font-mono text-[10px] uppercase">{a.type}</Badge>
                <span className="font-medium">{a.title}</span>
              </div>
              <div className="text-xs text-slate-500 mt-1">{a.candidate_name} {a.due_at && `· ${new Date(a.due_at).toLocaleString()}`}</div>
              {a.notes && <div className="text-xs text-slate-600 mt-1 italic">{a.notes}</div>}
            </div>
            <button onClick={() => remove(a.id)} className="p-2 text-slate-400 hover:text-red-600" data-testid={`action-del-${a.id}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>

      {done.length > 0 && (
        <div className="mt-10">
          <h2 className="font-display text-xl mb-4">Faits ({done.length})</h2>
          <div className="border border-slate-200 bg-white opacity-70">
            {done.map((a) => (
              <div key={a.id} className="flex items-center gap-4 p-4 border-b last:border-b-0 border-slate-100">
                <Checkbox checked onCheckedChange={() => toggle(a.id, false)} />
                <div className="flex-1 line-through text-slate-500">
                  <span className="font-medium">{a.title}</span> · {a.candidate_name}
                </div>
                <button onClick={() => remove(a.id)} className="p-2 text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
